import React, { useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

export const TransactionContext = React.createContext({});

export default function TransactionProvider({ children }) {
  const [transactionData, setTransactionData] = useState({});

  const contextValue = useMemo(
    () => ({
      transactionData,
      setTransactionData,
    }),

    [transactionData],
  );

  return (
    <TransactionContext.Provider value={contextValue}>
      {children}
    </TransactionContext.Provider>
  );
}

export function useTransactionData() {
  return useContext(TransactionContext);
}

TransactionProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.array,
    PropTypes.node,
  ]).isRequired,
};
